import { gql } from '@apollo/client';

export const GET_CUSTOMER_RFID_TOKENS = gql`
  query ReadRfidTokens {
    readRfidTokens {
      customerUid
      name
      serialNumber
    }
  }
`;
